import { FaReact, FaNodeJs, FaAws, FaDatabase, FaDocker, FaAngular, FaGithub, FaGitlab, FaGoogle, FaJava, FaJenkins, FaMicrosoft, FaPython, FaVuejs, FaAndroid, FaLaravel, FaGit } from 'react-icons/fa';
import { SiRubyonrails, SiPostgresql, SiMongodb, SiMaterialdesign, SiHtml5, SiCss3, SiJquery, SiAwsamplify, SiFirebase, SiTerraform, SiArgo, SiKotlin, SiJetpackcompose, SiGradle, SiDart, SiGraphql, SiBitrise, SiPhp, SiMysql, SiTypescript, SiSpringboot } from 'react-icons/si';
import { JSX } from '@emotion/react/jsx-runtime';
import { GrDeploy, GrKubernetes } from "react-icons/gr";


export const techIcons: { [key: string]: JSX.Element } = {
  "ReactJS": <FaReact />,
  "NodeJS": <FaNodeJs />,
  "TypeScript": <SiTypescript />,
  "AWS": <FaAws />,
  "Git": <FaGit />,
  "PHP": <SiPhp />,
  "PostgreSQL": <SiPostgresql />,
  "MongoDB": <SiMongodb />,
  "Ruby On Rails": <SiRubyonrails />,
  "Material UI": <SiMaterialdesign />,
  "HTML5": <SiHtml5 />,
  "CSS3": <SiCss3 />,
  "jQuery": <SiJquery />,
  "AWS-ECS": <SiAwsamplify />,
  // "Flutter": <FaFlutter/>,
  "Dart": <SiDart/>,
  'Cognito': <FaAws />,
  'Lambda': <FaAws />,
  'ECS': <FaAws />,
  'Android': <FaAndroid/>,
  'Kotlin': <SiKotlin/>,
  'Jetpack Compose': <SiJetpackcompose/>,
  'Room': <FaDatabase/>,
  'Database': <FaDatabase/>,
  'Bitrise': <SiBitrise/>,
  'Laravel': <FaLaravel/>,
  'Jenkins': <FaJenkins />,
  'Docker': <FaDocker />,
  'GraphQL': <SiGraphql />,
  'CI/CD': <FaGitlab />,
  'GitLab': <FaGitlab />,
  'GitHub': <FaGithub />,
  'Heroku': <GrDeploy />,
  'Netlify': <GrDeploy />,
  'Firebase': <SiFirebase />,
  'GCP': <FaGoogle />,
  'Azure': <FaMicrosoft />,
  'Kubernetes': <GrKubernetes />,
  'Terraform': <SiTerraform />,
  'ArgoCD': <SiArgo />,
  'Java': <FaJava />,
  'Spring Boot': <SiSpringboot />,
  'Python': <FaPython />,
  'Node.js': <FaNodeJs />,
  'Express.js': <FaNodeJs />,
  'Hibernate': <FaJava />,
  'Maven': <FaJava />,
  'Gradle': <SiGradle />,
  'JUnit': <FaJava />,
  'Mockito': <FaJava />,
  'Jest': <FaReact />,
  'React': <FaReact />,
  'Angular': <FaAngular />,
  'Vue.js': <FaVuejs />,
  'Next.js': <FaReact />,
  'Gatsby': <FaReact />,
  'Nuxt.js': <FaVuejs />,
  'Redux': <FaReact />,
  'Vuex': <FaVuejs />,
  'Tailwind CSS': <SiCss3 />,
  'Bootstrap': <SiCss3 />,
  'JQuery': <SiJquery />,
  'MySQL': <SiMysql />,
};
  